module.exports = __webpack_public_path__ + "img/promo-bg--1920.2b5e5f8.webp";